import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Header from '../components/header';
import "react-datetime/css/react-datetime.css";
import BaseURL from '../assets/contants/BaseURL';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSearch } from '@fortawesome/free-solid-svg-icons';
import * as ExcelJS from 'exceljs';
import '../scss/Proreport.scss';

const Productionreport = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [machineGroups, setMachineGroups] = useState([]);
  const [filteredMachines, setFilteredMachines] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);
  const [dailyreportData, setDailyreportData] = useState([]);
  const [currentdailyreportPage, setCurrentdailyreportPage] = useState(1);
  const [machineConfig, setMachineConfig] = useState({
    diesel: false,
    lpg: false,
    target_diesel: 0,
    target_lpg: 0
  });

  const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#333',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    transition: 'border-color 0.3s ease',
    width: '150px',
  };

  useEffect(() => {
    const fetchMachineGroups = async () => {
      try {
        const response = await axios.get(`${BaseURL}meters/machine/`);
        setMachineGroups(response.data);
        setFilteredMachines(response.data);
        if (response.data && response.data.length > 0) {
          const machine = response.data.find(m => m.machine_id === selectedMachine);
          if (machine) {
            setMachineConfig({
              diesel: machine.diesel,
              lpg: machine.lpg,
              target_diesel: machine.target_diesel,
              target_lpg: machine.target_lpg
            });
          }
        }
      } catch (error) {
        console.error("Error fetching machine groups:", error);
      }
    };
    fetchMachineGroups();
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);

    if (query.trim() === "") {
      setFilteredMachines(machineGroups);
      return;
    }

    const filtered = machineGroups.filter((machine) => {
      return machine.machine_id && machine.machine_id.toLowerCase().includes(query.toLowerCase());
    });

    setFilteredMachines(filtered);
  };

  const handleSelect = (machine) => {
    setSelectedMachine(machine.machine_id);
    setIsOpen(false);
  };

  const handleGetDailyReport = async () => {
    try {
      const response = await axios.post(`${BaseURL}meters/daily-production-report-update/`, {
        machine_id: selectedMachine,
        start_date: fromDate,
        end_date: toDate,
      });

      const data = response.data;
      console.log("Daily Report:", data);

      const formattedData = data.productions?.map(production => ({
        production_date: production.production_date,
        from_date: production.from_date_time,
        to_date: production.to_date_time,
        production: production.production || {},
        target_production: production.target_production || {},
        totalKwh: production.total_kwh || 0,
        totalCost: production.total_cost || 0,
        totalCo2: production.total_co2 || 0,
        sec: production.sec || {},
        energy_consumption: production.energy_consumption || {},
        energy_target: production.energy_target || {},
        production_per_energy: production.production_per_energy || {}
      })) || [];

      setDailyreportData(formattedData);
      setCurrentdailyreportPage(1);
    } catch (error) {
      console.error("Error fetching daily report:", error);
      setDailyreportData([]);
    }
  };

  const rowsdailyPerPage = 10;
  const totaldailyPages = Math.ceil((dailyreportData?.length || 0) / rowsdailyPerPage);
  const indexOfdailyLastRow = currentdailyreportPage * rowsdailyPerPage;
  const indexOfdailyFirstRow = indexOfdailyLastRow - rowsdailyPerPage;
  const currentDailyRows = dailyreportData?.slice(indexOfdailyFirstRow, indexOfdailyLastRow) || [];

  const handledailyPageChange = (newPage) => {
    setCurrentdailyreportPage(newPage);
  };

  const getProductionValue = (productionObj, key) => {
    if (!productionObj) return 0;
    return productionObj[key] || 0;
  };

  const getProductionKeys = () => {
    if (!dailyreportData || dailyreportData.length === 0) return [];
    const firstItem = dailyreportData[0];
    return firstItem?.production ? Object.keys(firstItem.production) : [];
  };

  const getEnergyColumns = () => {
    const columns = [];

    if (machineConfig.diesel) {
      columns.push(
        { key: 'diesel_consumption', label: 'Diesel', type: 'energy' },
        { key: 'diesel_target', label: 'Diesel Target', type: 'energy_target' },
        ...getProductionKeys().map(key => ({
          key: `diesel_per_${key}`,
          label: `Diesel/${key}`,
          type: 'production_per_energy',
          product: key
        }))
      );
    }

    if (machineConfig.lpg) {
      columns.push(
        { key: 'lpg_consumption', label: 'LPG', type: 'energy' },
        { key: 'lpg_target', label: 'LPG Target', type: 'energy_target' },
        ...getProductionKeys().map(key => ({
          key: `lpg_per_${key}`,
          label: `LPG/${key}`,
          type: 'production_per_energy',
          product: key
        }))
      );
    }

    return columns;
  };

  const handleExportToExcel = async (data, fileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Report');

    const getBase64FromImageUrl = async (url) => {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    };

    const getProductionKeys = () => {
      if (!data || data.length === 0) return [];
      const firstItem = data[0];
      return firstItem?.production ? Object.keys(firstItem.production) : [];
    };
    const productionKeys = getProductionKeys();

    let columnCount = 5 + (productionKeys.length * 3);
    if (machineConfig.diesel) columnCount += 2 + productionKeys.length;
    if (machineConfig.lpg) columnCount += 2 + productionKeys.length;

    for (let rowNum = 1; rowNum <= 3; rowNum++) {
      const row = worksheet.getRow(rowNum);
      for (let i = 1; i <= columnCount; i++) {
        row.getCell(i).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFDDDDDD' },
        };
      }
    }

    try {
      const logoBase64 = await getBase64FromImageUrl('/brad.png');
      const logoId = workbook.addImage({
        base64: logoBase64,
        extension: 'png'
      });

      const centerCol = Math.floor(columnCount / 2) - 1;
      worksheet.addImage(logoId, {
        tl: { col: centerCol, row: 0 },
        br: { col: centerCol + 1, row: 3 },
        editAs: 'oneCell'
      });

      worksheet.getRow(1).height = 30;
      worksheet.getRow(2).height = 30;
      worksheet.getRow(3).height = 30;
    } catch (error) {
      console.error('Error adding logo:', error);
    }

    const dateRow = worksheet.addRow([`From Date: ${fromDate || ''}, To Date: ${toDate || ''}`]);
    worksheet.mergeCells(dateRow.number, 1, dateRow.number, columnCount);
    dateRow.font = { bold: true, size: 14 };
    dateRow.alignment = { horizontal: 'center', vertical: 'middle' };
    dateRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9EAD3' },
      };
    });

    const branchRow = worksheet.addRow([`Site: Coimbatore | Machine ID: ${selectedMachine || ''}`]);
    branchRow.font = { bold: true, size: 12 };
    branchRow.alignment = { horizontal: 'center' };
    worksheet.mergeCells(branchRow.number, 1, branchRow.number, columnCount);
    branchRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
      };
    });

    const headers = ['Production Date', 'From Date', 'To Date', 'Total kWh', 'Total Cost'];

    productionKeys.forEach(key => {
      headers.push(key);
    });
    productionKeys.forEach(key => {
      headers.push(`Target ${key}`);
    });
    productionKeys.forEach(key => {
      headers.push(`EnPI ${key}`);
    });

    if (machineConfig.diesel) {
      headers.push('Diesel', 'Diesel Target');
      productionKeys.forEach(key => {
        headers.push(`Diesel/${key}`);
      });
    }
    if (machineConfig.lpg) {
      headers.push('LPG', 'LPG Target');
      productionKeys.forEach(key => {
        headers.push(`LPG/${key}`);
      });
    }

    const headerRow = worksheet.addRow(headers);
    headerRow.font = { bold: true };
    headerRow.eachCell(cell => {
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFA500' },
      };
    });

    if (data && data.length > 0) {
      data.forEach((row, rowIndex) => {
        const rowData = [
          row.production_date || '',
          row.from_date || '',
          row.to_date || '',
          (row.totalKwh || 0).toFixed(2),
          (row.totalCost || 0).toFixed(2)
        ];

        productionKeys.forEach(key => {
          rowData.push(getProductionValue(row.production, key).toFixed(2));
        });

        productionKeys.forEach(key => {
          rowData.push(getProductionValue(row.target_production, key).toFixed(2));
        });

        productionKeys.forEach(key => {
          rowData.push(getProductionValue(row.sec, key).toFixed(2));
        });

        if (machineConfig.diesel) {
          rowData.push(
            (row.energy_consumption?.Diesel || 0).toFixed(2),
            (row.energy_target?.Diesel || 0).toFixed(2)
          );
          productionKeys.forEach(key => {
            rowData.push((row.production_per_energy?.Diesel?.[key] || 0).toFixed(2));
          });
        }

        if (machineConfig.lpg) {
          rowData.push(
            (row.energy_consumption?.LPG || 0).toFixed(2),
            (row.energy_target?.LPG || 0).toFixed(2)
          );
          productionKeys.forEach(key => {
            rowData.push((row.production_per_energy?.LPG?.[key] || 0).toFixed(2));
          });
        }

        const dataRow = worksheet.addRow(rowData);
        dataRow.height = 20;
        dataRow.eachCell(cell => {
          const fillColor = rowIndex % 2 === 0 ? 'FFE8EAF6' : 'FFFFFFFF';
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: fillColor },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
      });
    } else {
      const noDataRow = worksheet.addRow(['No data available']);
      noDataRow.font = { italic: true };
      worksheet.mergeCells(noDataRow.number, 1, noDataRow.number, columnCount);
    }

    const footerRow = worksheet.addRow(['Powered by Innospace']);
    footerRow.font = { bold: true, size: 12 };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };
    worksheet.mergeCells(footerRow.number, 1, footerRow.number, columnCount);
    footerRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
      };
    });

    const columnWidths = [
      20,
      20,
      20,
      15,
      15
    ];

    productionKeys.forEach(() => {
      columnWidths.push(15, 15, 15);
    });

    if (machineConfig.diesel) {
      columnWidths.push(15, 15);
      productionKeys.forEach(() => columnWidths.push(15));
    }
    if (machineConfig.lpg) {
      columnWidths.push(15, 15);
      productionKeys.forEach(() => columnWidths.push(15));
    }

    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }).catch(error => {
      console.error('Error exporting to Excel:', error);
    });
  };

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="PRODUCTION REPORTS" />
      </div>
      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '980px',
        marginLeft: 'auto',
        marginRight: 'auto',
        borderRadius: '8px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <label style={{ fontWeight: 'bold' }}>From Date:</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={inputStyle}
              max={new Date().toISOString().slice(0, 16)}
            />

            <label style={{ fontWeight: 'bold' }}>To Date:</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={inputStyle}
              max={new Date().toISOString().slice(0, 16)}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "-10px" }}>
            <div style={{ display: "flex", gap: "20px", width: "100%" }}>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    width: "90%",
                    padding: "6px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    boxShadow: '0 2px 4px rgba(0, 0, 0 , 0.1)',
                    position: "relative",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    onClick={() => setIsOpen(!isOpen)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      cursor: "pointer",
                      width: "160px",
                      fontSize: "12px",
                      padding: "5px",
                    }}
                  >
                    <span style={{ flex: 1, textAlign: "left" }}>{selectedMachine || "Select Machine"}</span>
                    <span style={{ fontSize: "10px" }}>
                      <i className="fa-solid fa-angle-down"></i>
                    </span>
                  </div>

                  {isOpen && (
                    <div
                      ref={dropdownRef}
                      style={{
                        position: "absolute",
                        top: "110%",
                        left: 0,
                        right: 0,
                        backgroundColor: "white",
                        borderRadius: "5px",
                        boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                        zIndex: 10,
                        maxHeight: "330px",
                        overflowY: "auto",
                        border: "1px solid #000",
                      }}
                    >
                      <div
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #ccc",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search Machine Group"
                          value={searchQuery}
                          onChange={(e) => handleSearch(e.target.value)}
                          style={{
                            width: "90%",
                            padding: "8px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>

                      {filteredMachines.length > 0 ? (
                        filteredMachines.map((machine) => (
                          <div
                            key={machine.id}
                            style={{
                              padding: "5px",
                              cursor: "pointer",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#006ec5";
                              e.target.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "black";
                            }}
                            onClick={() => handleSelect(machine)}
                          >
                            {machine.machine_id} - {machine.machine_name}
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "10px" }}>No results found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={handleGetDailyReport}
            style={{
              padding: '8px 12px',
              backgroundColor: '#007acc',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '8px',
            }}
          >
            <FontAwesomeIcon icon={faSearch} />
          </button>

          <button
            onClick={() => {
              const fileName = `Daily_Report_${fromDate}_to_${toDate}.xlsx`;
              handleExportToExcel(dailyreportData, fileName);
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: '#007acc',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '8px',
              marginRight: '20px',
            }}
          >
            <span>Download</span>
            <FontAwesomeIcon icon={faDownload} style={{ marginLeft: '5px' }} />
          </button>
        </div>
      </div>
      <div className="dashboards">
        <div className="Monthly-Reports">
          <div className="table-container" style={{ overflowX: 'auto' }}>
            <table style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th>Production Date</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Total kWh</th>
                  <th>Total Cost</th>
                  {getProductionKeys().map(key => (
                    <th key={`prod-${key}`}>{key}</th>
                  ))}
                  {getProductionKeys().map(key => (
                    <th key={`target-${key}`}>Target {key}</th>
                  ))}
                  {getProductionKeys().map(key => (
                    <th key={`sec-${key}`}>EnPI {key}</th>
                  ))}
                  {getEnergyColumns().map(col => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentDailyRows.length > 0 ? (
                  currentDailyRows.map((row, index) => (
                    <tr key={index}>
                      <td>{row.production_date}</td>
                      <td>{row.from_date}</td>
                      <td>{row.to_date}</td>
                      <td>{row.totalKwh.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td>{row.totalCost.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      {getProductionKeys().map(key => (
                        <td key={`prod-val-${key}-${index}`}>
                          {getProductionValue(row.production, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </td>
                      ))}
                      {getProductionKeys().map(key => (
                        <td key={`target-val-${key}-${index}`}>
                          {getProductionValue(row.target_production, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </td>
                      ))}
                      {getProductionKeys().map(key => (
                        <td key={`sec-val-${key}-${index}`}>
                          {getProductionValue(row.sec, key).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </td>
                      ))}
                      {machineConfig.diesel && (
                        <>
                          <td>
                            {row.energy_consumption?.Diesel?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                          </td>
                          <td>
                            {row.energy_target?.Diesel?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                          </td>
                          {getProductionKeys().map(key => (
                            <td key={`diesel-per-${key}-${index}`}>
                              {row.production_per_energy?.Diesel?.[key]?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                            </td>
                          ))}
                        </>
                      )}

                      {machineConfig.lpg && (
                        <>
                          <td>
                            {row.energy_consumption?.LPG?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                          </td>
                          <td>
                            {row.energy_target?.LPG?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                          </td>
                          {getProductionKeys().map(key => (
                            <td key={`lpg-per-${key}-${index}`}>
                              {row.production_per_energy?.LPG?.[key]?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                            </td>
                          ))}
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6 + getProductionKeys().length * 3 + getEnergyColumns().length} style={{ textAlign: "center" }}>
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="pagination-controls">
              <button
                disabled={currentdailyreportPage === 1 || currentDailyRows.length === 0}
                onClick={() => handledailyPageChange(currentdailyreportPage - 1)}
              >
                Previous
              </button>
              <span>  {currentdailyreportPage}   of   {totaldailyPages}  </span>
              <button
                disabled={currentdailyreportPage === totaldailyPages || currentDailyRows.length === 0}
                onClick={() => handledailyPageChange(currentdailyreportPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productionreport;